import { ShoppingCart, Package,ExternalLink } from "lucide-react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { CatalogItem } from "../types/catalog";
import { Analogs } from "./Analogs";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  description: string;
  stock: number;
  image: string;
}

interface ProductListItemProps {
  product: CatalogItem;
  onAddToCart: (product: CatalogItem,storage: string,price:number) => void;
  onViewDetails: (product: CatalogItem) => void;
  isInCartStorage:string[];
}

export function ProductListItem({ product, onAddToCart, onViewDetails,isInCartStorage  }: ProductListItemProps) {
    const kv: Record<string, string> = Object.fromEntries(
    (product.props?.prop ?? []).map(p => [p.code, p.value])
  );
      const navigate = useNavigate();
  const analoglist = kv['analog'] || '';
  const width = kv['width'] || '';
  const category = kv['category'] ;
  const model = kv['model'] || '';
  const pic='https://cdn.yutongoriginal.ru/product_images/'+product.code+'.jpg';
  const analogs = analoglist.split('/');
  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow border-blue-100 ">
      <div className="flex flex-col sm:flex-row gap-4 p-4">
        {/* Product Image */}
        <div 
          className="sm:w-48 sm:h-48 flex-shrink-0 cursor-pointer block"
          
        >
           <ImageWithFallback
                                  src={pic}
                                  alt={product.name}
                                  className="object-cover hover:scale-105 transition-transform"
                                />
        </div>

        {/* Product Info */}
        <div className="flex-1 flex flex-col justify-between min-w-0">
          <div>
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex-1 min-w-0 overflow-hidden">
                <Badge className="mb-2">
                  {category}
                </Badge>
                <h3 className="font-bold text-base mb-1 line-clamp-1 cursor-pointer">
                  <Button
                size="sm"
                variant="ghost"
                onClick={() =>
                  navigate(`/product/${product.code}`)
                }
                className="text-wrap"
              >{product.name}
              </Button></h3>
              </div>
            </div>
            
            <p className="text-gray-600 text-base mb-3 line-clamp-2" onClick={() => onViewDetails(product)}> {product.code}</p>
            <div  className='flex   flex-wrap'>Применяется: {model}</div>
            <div  className='flex   flex-wrap'>
            <Analogs product={product} onAddToCart={function (product: CatalogItem): void {
                throw new Error("Function not implemented.");
              } } onViewDetails={function (product: CatalogItem): void {
                throw new Error("Function not implemented.");
              } }/>
            </div >
          </div>

          {/* Bottom Section */}
           {product.storage?.map(stock => (   
          <div className="flex items-center justify-between gap-4 pt-3 border-t border-gray-200">
            <div className="flex items-center gap-2 text-base">
             <span>Склад {stock.storage}</span>  <Package className="h-4 w-4 text-gray-500" />
              <span className={stock.qty > 0 ? "text-green-600 font-medium" : "text-red-600 font-medium"}>
                {stock.qty > 0 ? `${stock.qty}` : 'под заказ'}
              </span>
            </div>
            <div className="flex items-center">
            <div className="text-base font-bold text-blue-600 pr-3">{stock.price.toFixed(0)}₽</div>

            <Button 
              className={isInCartStorage.includes(`${product.id}_${stock.storage}`)?"bg-gradient-to-br from-green-700 to-green-500": "bg-gradient-to-br from-blue-950 to-blue-800"} 
              onClick={async (e) => {
                e.stopPropagation();             
                try {
                  await onAddToCart(product, stock.storage, stock.price);
                } finally {
                  
                }
              }}
              disabled={stock.qty === 0}
            >
              <div className="text-right flex-shrink-0">
                
              </div>
              <ShoppingCart className="mr-2 h-4 w-4" />
               {isInCartStorage.includes(product.id+stock.storage)?"В корзине":stock.incart>0?"В корзине": "В корзину"}
            </Button>
          </div></div>
 ))}
        </div>
      </div>
    </Card>
  );
}
